import { Redirect, Switch } from 'react-router-dom';

import { USER_PERMISSIONS } from 'constants/userPermissions';
import { lazyWithChunkRecovery } from 'helper/lazyWithChunkRecovery';
import { PrivateLayout } from 'layouts';
import { PrivateRoute, AccessControlRoute } from 'components/routes';

import * as routes from './routes';

const Home = lazyWithChunkRecovery(() => import('screens/Home'));
const OrganisationsList = lazyWithChunkRecovery(() => import('screens/OrganisationsList'));
const AccountSettings = lazyWithChunkRecovery(() => import('screens/AccountSettings'));
const NewCulturalProject = lazyWithChunkRecovery(() => import('screens/NewCulturalProject'));
const NewProjectSuccess = lazyWithChunkRecovery(() => import('screens/NewProjectSuccess'));
const CulturalProjectAdvancedSettings = lazyWithChunkRecovery(() => import('screens/CulturalProjectAdvancedSettings'));
const Dashboard = lazyWithChunkRecovery(() => import('screens/Dashboard'));
const DashboardBucket = lazyWithChunkRecovery(() => import('screens/DashboardBucket'));
const PersonalTracker = lazyWithChunkRecovery(() => import('screens/PersonalTracker'));
const NewFeedbackFramework = lazyWithChunkRecovery(() => import('screens/NewFeedbackFramework'));
const NewFeedbackSuccess = lazyWithChunkRecovery(() => import('screens/NewFeedbackSuccess'));
const ViewNominees = lazyWithChunkRecovery(() => import('screens/ViewNominees'));
const FeedBackNominees = lazyWithChunkRecovery(() => import('screens/FeedBackNominees'));
const NomineeReject = lazyWithChunkRecovery(() => import('screens/NomineeReject'));
const Report = lazyWithChunkRecovery(() => import('screens/Report'));
const TeamReport = lazyWithChunkRecovery(() => import('screens/TeamReport'));
const ProjectList = lazyWithChunkRecovery(() => import('screens/ProjectList'));
const ManageUsers = lazyWithChunkRecovery(() => import('screens/ManageUsers'));
const PersonalProjects = lazyWithChunkRecovery(() => import('screens/PersonalProjects'));
const DashboardPortfolio = lazyWithChunkRecovery(() => import('screens/DashboardPortfolio'));
const CreateProject = lazyWithChunkRecovery(() => import('screens/CreateProject'));
const SecuritySettings = lazyWithChunkRecovery(() => import('screens/SecuritySettings'));
const ActivityLog = lazyWithChunkRecovery(() => import('screens/ActivityLog'));
const OrganisationOverview = lazyWithChunkRecovery(() => import('screens/OrganisationOverview'));
const ProjectJournals = lazyWithChunkRecovery(() => import('screens/ProjectJournals'));
const PersonalJournals = lazyWithChunkRecovery(() => import('screens/PersonalJournals'));
const ActionTracker = lazyWithChunkRecovery(() => import('screens/ActionTracker'));

const PrivateRoutes = () => {
  return (
    <PrivateLayout>
      <Switch>
        <PrivateRoute exact path={routes.home} component={Home} />
        <PrivateRoute exact path={routes.organisationsList} component={OrganisationsList} />
        <PrivateRoute exact path={routes.accountSettings} component={AccountSettings} />

        <PrivateRoute
          exact
          path={`/:organisationId?/${routes.newCulturalProject}/:id?`}
          component={NewCulturalProject}
        />
        <PrivateRoute exact path={`/:organisationId?/${routes.newProjectUsers}/:id`} component={NewProjectSuccess} />
        <PrivateRoute
          exact
          path={`/:organisationId?/${routes.culturalProjectAdvancedSettings}/:id`}
          component={CulturalProjectAdvancedSettings}
        />
        <PrivateRoute exact path={`/:organisationId?/${routes.dashboard}/:id`} component={Dashboard} />
        <PrivateRoute exact path={`/:organisationId/${routes.dashboardBucket}/:id`} component={DashboardBucket} />
        <PrivateRoute
          exact
          path={`/:organisationId/${routes.personalTracker}/:projectId`}
          component={PersonalTracker}
        />

        <PrivateRoute
          exact
          path={`/:organisationId/${routes.newFeedbackFramework}/:id?`}
          component={NewFeedbackFramework}
        />
        <PrivateRoute
          exact
          path={`/:organisationId/${routes.newFeedbackRecipient}/:id`}
          component={NewFeedbackSuccess}
        />
        <PrivateRoute
          exact
          path={`/:organisationId/${routes.viewNominees}/:frameworkId/:userId`}
          component={ViewNominees}
        />
        <PrivateRoute exact path={`${routes.feedbackNominees}/:frameworkId`} component={FeedBackNominees} />
        <PrivateRoute exact path={`${routes.recipientReject}/:frameworkId/:id`} component={NomineeReject} />
        <PrivateRoute exact path={`${routes.report}/:frameworkId/:id`} component={Report} />
        <AccessControlRoute exact path={`${routes.teamReport}/:organisationId/:id`} component={TeamReport} />

        <AccessControlRoute exact path={`${routes.projectList}/:organisationId`} component={ProjectList} />
        <AccessControlRoute exact path={`${routes.manageUsers}/:organisationId?`} component={ManageUsers} />
        <PrivateRoute exact path={`${routes.personalProjects}/:organisationId`} component={PersonalProjects} />
        <PrivateRoute path={`${routes.dashboardPortfolio}/:organisationId`} component={DashboardPortfolio} />
        <AccessControlRoute exact path={`${routes.createProject}/:organisationId`} component={CreateProject} />
        <PrivateRoute exact path={`${routes.actionTracker}/:organisationId`} component={ActionTracker} />
        <PrivateRoute path={`${routes.projectJournals}/:organisationId`} component={ProjectJournals} />
        <PrivateRoute path={`${routes.personalJournals}/:organisationId`} component={PersonalJournals} />
        <AccessControlRoute exact path={`${routes.securitySettings}/:organisationId`} component={SecuritySettings} />
        <AccessControlRoute exact path={`${routes.activityLog}/:organisationId?`} component={ActivityLog} />
        <AccessControlRoute
          allow={[USER_PERMISSIONS.SUPER_ADMIN]}
          path={`${routes.organisationOverview}`}
          component={OrganisationOverview}
        />

        <Redirect from="*" to={routes.home} />
      </Switch>
    </PrivateLayout>
  );
};

export default PrivateRoutes;
